import React, {
	useReducer,
	useContext,
	createContext,
	useCallback,
} from "react";
import API from "../../network/redAPI";

const TYPES = {
	fetchStoreLogo: "FETCH_STORE_LOGO",
};

const reducer = (state, action) => {
	switch (action.type) {
		case TYPES.fetchStoreLogo:
			return {
				...state,
				storeLogo: action.payload,
			};
		case "":
			return { ...state };
		default:
			throw new Error(`Unknown action: ${action.type}`);
	}
};

const INITIAL_STATE = {
	storeLogo: { express: "", normal: "" },
};

const useStoreLogoActions = (initialState = INITIAL_STATE) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	const FetchStoreLogo = useCallback(() => {
		API.getStoreLogo()
			.then((res) => res.json())
			.then((res) => {
				const { success, data } = res;
				let dispatchData = {};
				if (success) {
					if (data.logo) {
						if (data.logo?.express) {
							dispatchData.express = data.logo.express?.logoUrl;
						}
						if (data.logo?.normal) {
							dispatchData.normal = data.logo.normal?.logoUrl;
						}
						dispatch({
							type: TYPES.fetchStoreLogo,
							payload: dispatchData,
						});
					}
				} else {
					console.log("<<< Store Logo >>> ", res?.message);
				}
			})
			.catch((err) => {
				console.error("<<< Store Logo >>> ", err);
			});
	}, []);

	return {
		state,
		FetchStoreLogo,
	};
};

export const StoreLogoContext = createContext({});

export const StoreLogoProvider = ({ children }) => {
	const { state, FetchStoreLogo } = useStoreLogoActions();

	return (
		<StoreLogoContext.Provider
			value={{
				state: state,
				storeLogo: state.storeLogo,
				fetchStoreLogo: FetchStoreLogo,
			}}
		>
			{children}
		</StoreLogoContext.Provider>
	);
};

export const useStoreLogo = () => useContext(StoreLogoContext);
